import styled, { useTheme } from 'styled-components';
import useFetch from '../../../api/useFetch';
import {
  bomListGetApi,
  bomPostApi,
  BomRequestType,
  ItemBomResponseEssType,
  ItemBomResponseType,
  ItemBomType,
  itemListGetApi,
  parcelItemListAllGetApi,
  parcelItemListGetApi,
  parcelItemPostApi,
  ParcelItemResponseType,
  parcelTraderListAllGetApi,
  parcelTraderPostApi,
  ParcelTraderResponseType,
  ProductItem,
  traderAbbrListGetApi,
  traderAbbrPostApi,
  TraderAbbrType,
  traderListGetApi,
  TraderType,
} from '../../../api/apiConfig';
import { useEffect, useState } from 'react';
import { BomEditModal } from '../../../component/common/modal/ModalComponents/BomEditModal';
import { ParcelItemEditModal } from '../../../component/common/modal/ModalComponents/ParcelItemEditModal';
import { ParcelTraderEditModal } from '../../../component/common/modal/ModalComponents/ParcelTraderEditModal';
import { InputUnderline } from '../../../component/input/InputUnderline';
import { IoSaveOutline } from 'react-icons/io5';
import { SearchBar } from '../../../component/common/SearchBar';
import { useHeaderButtons } from '../../../component/header/HeaderButtonProvider';
import SquareButton from '../../../component/button/SquareButton';

export const TraderAbbreviationPage = () => {
  const [traderAbbrs, setTraderAbbrs] = useState<TraderAbbrType[]>([]);

  const { setButtons } = useHeaderButtons();

  const theme = useTheme();

  const [searchTerm, setSearchTerm] = useState<string>('');

  const { fetch: fetchTraderAbbrListGetApi } = useFetch({
    fetchFunction: traderAbbrListGetApi,
    onSuccess: (data: TraderAbbrType[]) => setTraderAbbrs(data),
  });

  const { fetch: fetchTraderAbbrPostApi } = useFetch({
    fetchFunction: traderAbbrPostApi,
    onSuccess: (data: TraderAbbrType[]) =>
      setTraderAbbrs((prev) =>
        prev.map((abbr) => {
          const matchedData =
            data.find((newAbbr) => newAbbr.CUST_CODE === abbr.CUST_CODE) ||
            null;

          if (matchedData == null) {
            return abbr;
          } else {
            return {
              ...abbr,
              abbr: matchedData.abbr,
            };
          }
        })
      ),
  });

  useEffect(() => {
    fetchTraderAbbrListGetApi();
  }, []);

  useEffect(() => {
    //헤더에 버튼 추가
    setButtons(
      <>
        <SquareButton
          text='일괄 저장'
          colorType='ACTIVE'
          onClick={() => saveHandler()}
        />
      </>
    );
    // 페이지가 바뀌면 버튼 초기화
    return () => setButtons(null);
  }, [setButtons]);

  function saveHandler() {
    const changedDivs = document.querySelectorAll('.updated-true');

    const dtoList: TraderAbbrType[] = [];

    changedDivs.forEach((div) => {
      // div의 자식 요소인 input 찾기
      const input = div.querySelector('input');

      if (input) {
        // input의 id와 value를 가져오기
        const inputId = input.getAttribute('id');
        const inputValue = input.value;

        if (inputId == null) return;

        const dto: TraderAbbrType = {
          CUST_CODE: inputId,
          abbr: inputValue,
          CUST_DES: '',
        };
        dtoList.push(dto);
      }
    });
    fetchTraderAbbrPostApi(dtoList);
  }

  const InputArea = ({ trader }: { trader: TraderAbbrType }) => {
    const [inputText, setInputText] = useState<string>(trader.abbr || '');

    const [isUpdated, setIsUpdated] = useState<boolean>(false);

    useEffect(() => {
      if (
        (trader.abbr == null || trader.abbr?.trim() === '') &&
        inputText.trim() !== ''
      ) {
        setIsUpdated(true);
      } else if (
        trader.abbr != null &&
        trader.abbr?.trim() !== '' &&
        trader.abbr !== inputText
      ) {
        setIsUpdated(true);
      } else {
        setIsUpdated(false);
      }
    }, [inputText]);

    return (
      <div
        className={`label flex-center updated-${isUpdated}`}
        style={{ position: 'relative' }}
      >
        <input
          value={inputText}
          id={trader.CUST_CODE}
          onChange={(e) => setInputText(e.target.value)}
          placeholder='등록된 이름이 없습니다'
          style={{
            width: '60%',
            border: 'none',
            outline: 'none',
            fontWeight: 500,
            fontSize: '15px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            // color: isUpdated ? 'black' : 'gray',
          }}
          onFocus={(e) => (e.target.placeholder = '')}
          onBlur={(e) => (e.target.placeholder = '등록된 이름이 없습니다')}
        />
      </div>
    );
  };

  return (
    <Container>
      <h2 style={{ marginTop: '0px' }}>거래처 약칭 목록</h2>
      <SearchBar onSearch={setSearchTerm} width='400px' margin='0 0 10px 0' />
      <RowContainer>
        <HeaderRow>
          <h4 className='prod-des flex-center'>거래처명</h4>
          <h4 className='label flex-center'>페이지에서 사용될 이름</h4>
        </HeaderRow>
        {traderAbbrs.length > 0 &&
          traderAbbrs
            .filter((trader) => {
              if (searchTerm.trim() === '') {
                return true;
              } else {
                return (
                  trader.CUST_DES.includes(searchTerm) ||
                  trader.abbr?.includes(searchTerm)
                );
              }
            })
            .map((trader, index) => {
              return (
                <Row odd={index % 2 === 1}>
                  <h5 className='prod-des flex-center'>{trader.CUST_DES}</h5>
                  <InputArea trader={trader} />
                </Row>
              );
            })}
        <Row></Row>
      </RowContainer>
    </Container>
  );
};

const Container = styled.div``;

const RowContainer = styled.div`
  /* background-color: white; */
`;

const Row = styled.div<{ odd?: boolean }>`
  display: flex;
  width: 100%;
  height: 32px;
  flex-direction: row;
  align-items: center;

  background-color: ${({ odd, theme }) =>
    odd ? theme.colors.white_odd : theme.colors.white};

  .prod-des {
    flex: 1 0 20%;
    &:hover {
      text-decoration: underline;
      font-weight: 700;
      cursor: pointer;
    }
  }
  .label {
    flex: 1 0 20%;
  }
`;

const HeaderRow = styled(Row)`
  height: 30px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.charcoal};
  box-sizing: border-box;
  .has-bom {
    &:hover {
      text-decoration: none;
      cursor: auto;
    }
  }
`;
